import { useState } from "react";
import { Link } from "react-router-dom";
import { useForgotPasswordMutation } from "../../features/api/authApiSlice";
import FuelLoading from "../../pages/FuelLoading";
import "./auth.scss";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [forgotPassword, { isLoading }] = useForgotPasswordMutation();
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [fieldError, setFieldError] = useState(false);

  const handleInputChange = (e) => {
    setEmail(e.target.value);
    if (error) setError("");
    if (fieldError) setFieldError(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");
    setError("");

    if (!email.trim()) {
      setError("Please fill out your email address.");
      setFieldError(true);
      return;
    }

    try {
      const res = await forgotPassword(email.trim().toLowerCase()).unwrap();
      setMessage(res?.message || "Reset link sent if an account exists.");
      setEmail("");
    } catch (err) {
      setError(err?.data?.message || "Request failed. Please try again.");
    }
  };

  return (
    <main className="auth-page">
      {isLoading ? (
        <div className="auth-loading-box">
          <FuelLoading text="Sending reset coordinates down the road..." />
        </div>
      ) : (
        <form
          className="auth-card fuel-fade-in"
          onSubmit={handleSubmit}
          noValidate
        >
          <div className="auth-card__title">
            <h1>Forgot Password</h1>
            <p>Enter your email and we'll send you a reset link.</p>
          </div>

          <div className="auth-form-group">
            <div className="auth-input-wrapper">
              <label htmlFor="forgot-email">
                Email Address <span className="required-star">*</span>
              </label>
              <input
                id="forgot-email"
                type="email"
                className={fieldError ? "input-error" : ""}
                value={email}
                onChange={handleInputChange}
                placeholder="driver@roadtrip.com"
              />
            </div>
          </div>

          {error && <div className="auth-error-banner">{error}</div>}
          {message && (
            <div
              className="auth-inline-success"
              style={{ fontSize: "0.9rem", margin: "1rem 0" }}
            >
              {message}
            </div>
          )}

          <button
            type="submit"
            className="fuel-primary-btn register-submit-btn"
          >
            Send Reset Link
          </button>

          <footer className="auth-card__footer">
            <span>
              Remembered it?{" "}
              <Link to="/login" className="footer-auth-link">
                Login
              </Link>
            </span>
          </footer>
        </form>
      )}
    </main>
  );
}
